import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ContractInterface, UserInterface } from '../../../../core';
import { DictionaryDialog } from '../../dialog/dictionary/dictionary.dialog';
import { PhoneDialog } from '../../dialog/phone/phone.dialog';

@Component({
    selector: 'thr-header-onboarding',
    templateUrl: './header-onboarding.component.html',
    styleUrls: ['./header-onboarding.component.scss'],
})
export class HeaderOnboardingComponent {
    @Input()
    agent: UserInterface;

    @Input()
    contract: ContractInterface;

    @Input()
    showBack = false;

    @Output()
    back: EventEmitter<boolean> = new EventEmitter();

    constructor(private dialog: MatDialog) {}

    onBack() {
        this.back.emit(true);
    }

    onDictionary() {
        this.dialog.open(DictionaryDialog);
    }

    onPhone() {
        this.dialog.open(PhoneDialog);
    }
}
